import { apiRequest } from './apiClient';

// ====================
// USERS (admin/user)
// ====================

export const getUsers = () =>
  apiRequest('admin/user/users', 'GET');

export const createUser = (userData) =>
  apiRequest('admin/user/create', 'POST', userData);

export const updateUser = (userData) =>
  apiRequest('admin/user/update', 'POST', userData);

export const DeactivateUser = (payload) =>
  apiRequest('admin/user/deactivate', 'POST',  payload);

export const getLogs = () => apiRequest("admin/user/log", "GET");

export const postFilters = (filters) =>
  apiRequest("admin/user/logFilter", "POST", filters);

// ====================
// STATION ASSIGNMENT (admin/user)
// ====================

export const assignStationsToUser = (payload) =>
  apiRequest('admin/user/assign-station', 'POST',  payload );

export const RemoveStationUser = (payload) =>
  // POZOR: backend je /admin/user/remove-assign-station
  // payload možná bude chtít i user_id (dle implementace removeAssignStation)
  apiRequest('admin/user/remove-assign-station', 'POST', payload );

// ====================
// STATIONS (admin/station)
// ====================

export const getArmexStations = () =>
  apiRequest('admin/station/armex', 'GET');

export const getRoles = () =>
  apiRequest('admin/user/roles', 'GET');

export const getStationsArmexData = () =>
  apiRequest('admin/station/armex-data-stations', 'GET');



export const deleteStationStation = (AremxStation, RegularStation) =>
  // backend: /admin/station/remove-assign
  // POZOR: název funkce sugeruje remove-station-station, ale routa je remove-assign
  apiRequest('admin/station/remove-assign', 'POST', { armex_station_id: AremxStation, nearby_station_id: RegularStation });

export const updateArmexStationsOnBackend = (stationId, data) =>
  // backend: /admin/station/update-details
  apiRequest('admin/station/update-details', 'POST', { stationId, data });

export const assignNearbyStation = (data) =>
  // backend: /admin/station/assign-stations
  apiRequest('admin/station/assign-stations', 'POST', data);

export const updateNearbyPriceDifference = (payload) =>
  apiRequest(
    'admin/station/nearby-price-difference',
    'POST',
    payload
  );

export const AddNewStation = (data) =>
  // backend: /admin/station/add
  apiRequest('admin/station/add', 'POST', data);

export const SetStationActive = (payload) =>
  apiRequest('admin/station/deactivate', 'POST',  payload);

export const limitsSend = (data) =>
  // backend: /admin/station/limit-set
  apiRequest('admin/station/limit-set', 'POST', data);

// ====================
// PRICES
// ====================

// non-admin protected
export const submitPrices = (data) =>
  apiRequest('stations/price/submit', 'POST', data);

export const submitPricesUser = (data) =>
  apiRequest('stations/price/submit-user-confirm', 'POST', data);

// admin prices
export const submitPricesAdmin = (data) =>
  apiRequest('admin/prices/submit', 'POST', data);

export const submitPricesAdminWithoutChange = (data) =>
  apiRequest('admin/prices/submit-confirm-nochange', 'POST', data);

export const submitSchedulePriceChange = (data) =>
  apiRequest('admin/prices/schedule-change', 'POST', data);

export const displayPlannedPrices = (data) =>
  apiRequest('admin/prices/planned-display', 'POST', data);

export const deletePlannedPrice = (id) =>
  apiRequest('admin/prices/planned-removed', 'POST', { id });

export const displayShop2000Prices = (data) =>
  apiRequest('display-shop2000', 'POST', data);

// ====================
// INTERNAL mimo api/v1 internal 
// ====================

export const testtest = () =>
 
  apiRequest('stations/price/check-scheduled-change', 'GET');


export const displayHistory = (data) =>
  apiRequest('admin/prices/display-history', 'POST', data);

export const getHistoryChangesSummary = (data) =>
  apiRequest('admin/prices/history-changes-summary', 'POST', data);

export const toggleStationPriceType = (payload) => 
  apiRequest("/admin/station/price-type", 'POST', payload);



export const getPriceDashboard = async ({ category = "all", limit = 10 } = {}) => {
  const params = new URLSearchParams();

  if (category) params.set("category", category);
  if (limit) params.set("limit", String(limit));

  return apiRequest(`admin/price-dashboard?${params.toString()}`, "GET");
};

export const confirmDashboardNoChange = async ({ items }) => {
  return apiRequest("admin/price-dashboard/confirm-nochange", "POST", {
    items,
  });
};

/*export const exportPricesToExcel = async (payload) => {
  const response = await apiRequest('admin/prices/export', 'POST', payload, null, 'blob');

  if (!response || !response.blob) {
    throw new Error('Backend nevrátil platný export.');
  }

  return {
    blob: response.blob,
    filename: response.filename || `armex-csph-export-${new Date().toISOString().slice(0, 10)}.xlsx`,
  };
};*/

export const exportPricesToExcel = async (payload) => {
  const response = await apiRequest(
    'admin/prices/export',
    'POST',
    payload,
    null,
    'blob'
  );

  if (!response || !response.blob) {
    throw new Error('Backend nevrátil platný export pro Excel.');
  }

  const filename = response.filename || `armex-csph-export-${new Date().toISOString().slice(0, 10)}.xlsx`;

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const url = window.URL.createObjectURL(response.blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return {
    blob: response.blob,
    filename,
  };
};

export const sendUserInvite = (payload) =>
  apiRequest('admin/user/send-invite', 'POST', payload);


export const requestPasswordReset = ({ username, email }) =>
  apiRequest('password-reset/request', 'POST', { username, email });

export const confirmPasswordReset = ({ token, password }) =>
  apiRequest('password-reset/confirm', 'POST', { token, password });

